<div id="toggler" class="row py-2 px-3 align-items-center" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div class="col-3 col-sm-2">{{ material.materialNr.value }} <br />{{ material.descTxt }}</div>
    <div class="col-2">{{ material.storageLoc.value }} <br />{{ material.storageLocDesc }}</div>
    <div class="col-2">
        <span>{{ material.available }}</span>
        <span>&nbsp;</span>
        <span>{{ material.extUnit }}</span>
    </div>
    <div class="col-3">
        @if (displayCustomerPrice) {
            <strong translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_CLP"></strong>
            {{ material.customerPrice }} {{ material.customerCurrency }}
        }
        @if (displayRepairPrice) {
            <br />
            <strong translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_CRP"></strong>
            {{ material.repairPrice }} {{ material.repairCurrency }}
        }
    </div>
    <div class="col-1">
        <button
            type="button"
            class="btn btn-warning float-end"
            (click)="deleteMaterial()"
            [attr.aria-label]="'MATERIAL_AVAILABILITY_DELETE_MATERIAL_ARIA_LABEL' | translate"
        >
            <fa-icon [icon]="faTrashAlt" class="fa-xs"></fa-icon>
        </button>
    </div>
</div>

@if (!isCollapsed) {
    <div class="py-3">
        <div class="row align-items-top">
            <span
                class="col-form-label col-lg-3 col-12 text-start text-lg-end"
                translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_MAT_INFO"
            ></span>
            <div class="col-lg-8 col-12 pt-2">
                @if (material.longText.length > 0) {
                    @for (line of material.longText; track line) {
                        <span class="user-select-auto">{{ line }} <br /> </span>
                    }
                }
                <span>
                    <strong translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_TS"></strong>
                    {{ material.tsPercentage }}% / {{ material.tsPercentageCounter }}
                </span>
                <span class="ms-4">
                    <strong translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_NDF"></strong>
                    {{ material.ndfQuote }}% / {{ material.ndfCounter }}
                </span>
            </div>
        </div>
        @if (isDeliveryCutoffTimeEnabled && deliveryCutoffTimes?.length) {
            <div class="row mt-3 d-flex d-lg-none">
                <div
                    class="col-12 col-form-label text-start"
                    translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_TIMES_LABEL"
                ></div>
            </div>
            <div class="row mt-3 d-lg-flex d-none">
                <div
                    class="col-3 col-form-label text-end"
                    translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_TIMES_LABEL"
                ></div>
                <div class="col-11 offset-1 table-header text-center py-1 row">
                    <div
                        class="col-2"
                        translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_CSML_CODE_TABLE_HEADER_LABEL"
                    ></div>
                    <div
                        class="col-1"
                        translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_QUANTITY_TABLE_HEADER_LABEL"
                    ></div>
                    <div
                        class="col-2"
                        translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_CSML_NAME_TABLE_HEADER_LABEL"
                    ></div>
                    <div
                        class="col-1"
                        translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_STATE_TABLE_HEADER_LABEL"
                    ></div>
                    <div
                        class="col-2"
                        translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_OVERNIGHT_TABLE_HEADER_LABEL"
                    ></div>
                    <div
                        class="col-2"
                        translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_SATURDAY_TABLE_HEADER_LABEL"
                    ></div>
                    <div
                        class="col-2"
                        translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_HEAVYWEIGHT_TABLE_HEADER_LABEL"
                    ></div>
                </div>
            </div>
            @for (cutoffTimeLine of deliveryCutoffTimes; track cutoffTimeLine) {
                <div class="d-lg-flex d-lg-none py-2 ps-3">
                    <div class="row pb-1">
                        <div
                            class="col-5"
                            translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_CSML_CODE_TABLE_HEADER_LABEL"
                        ></div>
                        <div class="col">{{ cutoffTimeLine.csmlCode }}</div>
                    </div>
                    <div class="row">
                        <div
                            class="col-5"
                            translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_QUANTITY_TABLE_HEADER_LABEL"
                        ></div>
                        <div class="col">{{ cutoffTimeLine.quantity }}</div>
                    </div>
                    <div class="row pb-1">
                        <div
                            class="col-5"
                            translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_CSML_NAME_TABLE_HEADER_LABEL"
                        ></div>
                        <div class="col">{{ cutoffTimeLine.csmlName }}</div>
                    </div>
                    <div class="row pb-1">
                        <div
                            class="col-5"
                            translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_STATE_TABLE_HEADER_LABEL"
                        ></div>
                        <div class="col">{{ cutoffTimeLine.state }}</div>
                    </div>
                    <div class="row pb-1">
                        <div
                            class="col-5"
                            translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_OVERNIGHT_TABLE_HEADER_LABEL"
                        ></div>
                        <div class="col">{{ cutoffTimeLine.overnight }}</div>
                    </div>
                    <div class="row pb-1">
                        <div
                            class="col-5"
                            translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_SATURDAY_TABLE_HEADER_LABEL"
                        ></div>
                        <div class="col">{{ cutoffTimeLine.saturday }}</div>
                    </div>
                    <div class="row pb-1">
                        <div
                            class="col-5"
                            translate="MATERIAL_CUSTOMER_PRICING_DELIVERY_CUTOFF_HEAVYWEIGHT_TABLE_HEADER_LABEL"
                        ></div>
                        <div class="col">{{ cutoffTimeLine.heavyweight }}</div>
                    </div>
                    <hr class="separator" />
                </div>
                <div class="col-11 offset-1 row text-center d-lg-flex d-none py-2">
                    <div class="col-2">{{ cutoffTimeLine.csmlCode }}</div>
                    <div class="col-1">{{ cutoffTimeLine.quantity }}</div>
                    <div class="col-2">{{ cutoffTimeLine.csmlName }}</div>
                    <div class="col-1">{{ cutoffTimeLine.state }}</div>
                    <div class="col-2">{{ cutoffTimeLine.overnight }}</div>
                    <div class="col-2">{{ cutoffTimeLine.saturday }}</div>
                    <div class="col-2">{{ cutoffTimeLine.heavyweight }}</div>
                </div>
            }
        }
        <div class="row align-items-center">
            <div class="col-5 col-lg-3 col-form-label text-start text-lg-end">
                <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_REQUESTED"></span>
                <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_UNIT"></span>
            </div>
            <div class="col-7 col-lg-9">{{ material.quantity.value }} {{ material.extUnit }}</div>
        </div>
        <div class="row align-items-center">
            <div class="col-5 col-lg-3 col-form-label text-start text-lg-end">
                <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_AVAILABLE"></span>
                <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_UNIT"></span>
            </div>
            <div class="col-7 col-lg-9">{{ material.available }} {{ material.extUnit }}</div>
        </div>
    </div>
}
